import React from 'react';
export const deleteAnnotation = ({
  version: 1,
  id: 'delete-annotation',
  render: () => <div>You can click on delete button to delete the annotation.</div>
} as const);
export const hideAnnotation = ({
  version: 1,
  id: 'hide-annotation',
  render: () => <div>You can click on the hide button to hide the annotation</div>,
  nextId: deleteAnnotation.id
} as const);
export const selectAnnotation = ({
  version: 1,
  id: 'select-annotation',
  render: () => <div>Click on the annotation section to select the annotation.</div>,
  nextId: hideAnnotation.id,
  isRoot: true,
  disableNext: false
} as const);
export const ANNOTATION_ITEM_TUTORIAL_CONFIG = ({
  selectAnnotation,
  hideAnnotation,
  deleteAnnotation
} as const);